import React, { useContext } from "react";
import BaseLiveItem from "./BaseLiveItem";
import LiveBundledItem from "./LiveBundledItem";
import { StoreContext } from "shared/context/store-context";
import { AuthContext } from "shared/context/auth-context";
import { COMPANY_DOMAINS, COMPANY_FEATURES } from "@routebot/constants";

// Student track-vehicle detail. Vehicle routes live in the global store; bundled (multi-school)
// routes do NOT. So if the selected id isn't a known vehicle route, treat it as a bundled route
// and render the isolated bundled detail (keeps the shared BaseLiveItem untouched).
// Only fall through to bundled when the company actually has the feature; otherwise a stale/unknown
// id would hit the feature-gated bundled endpoint and surface a 403 instead of a clean not-found.
const LiveStudentItem = ({ itemId }) => {
  const { vehicleRoutes } = useContext(StoreContext);
  const auth = useContext(AuthContext);
  const isVehicleRoute = (vehicleRoutes || []).some((r) => String(r.id) === String(itemId));
  const bundledEnabled = !!auth?.company?.features?.[COMPANY_FEATURES.BUNDLED_STUDENT_ROUTES];

  if (!isVehicleRoute && bundledEnabled) {
    return <LiveBundledItem itemId={itemId} />;
  }
  return <BaseLiveItem itemId={itemId} mode={COMPANY_DOMAINS.STUDENT} />;
};

export default LiveStudentItem;
